<template>
  <div id="service-flow">
    <div class="flow">
      <ul class="flow-list">
        <li class="item" v-for="item of list" :key="item.id">
          <span class="iconfont" v-html="item.icon"></span>
          <span class="title">{{ item.title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceFlow",
  components: {},
  data() {
    return {
      list: [
        { id: 1, icon: "&#xe618;", title: "咨询签约" },
        { id: 2, icon: "&#xe730;", title: "病例翻译" },
        { id: 3, icon: "&#xe616;", title: "医院预约" },
        { id: 4, icon: "&#xe666;", title: "签证办理" },
        { id: 5, icon: "&#xe615;", title: "酒店住宿" },
        { id: 6, icon: "&#xe617;", title: "全程陪诊" }
      ]
    };
  },
  mounted() {},
  methods: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
#service-flow {
  .flow {
    .flow-list {
      display: flex;
      margin: 0 10px;
      .item {
        height: 68px;
        flex: 1;
        margin-right: 12px;
        box-shadow: 0 5px 16px 2px rgba(168, 216, 255, 0.23);
        text-align: center;
        border-radius: 8px;
        .iconfont {
          color: #2e96ea;
          font-size: 26px;
          line-height: 68px;
        }
        .title {
          color: #a0a0a0;
          font-size: 20px;
          line-height: 68px;
          margin-left: 9px;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
